import { IInitialChatData } from '../../../server/service/InitialChatData';
import { widgetSDK } from '../../sdk/widgetSDK';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';
import { RestartChatParameters } from '../reducers/types';
import { selectSelectedSite } from '../selectors/sites';
import { store } from '../store';
import { addToQueue, debug, handleConflictStatus } from './utils';

const { clientTopology, queryParams: query } = renderModel.get();

export const sendRestartChat = (
  parameters?: RestartChatParameters,
  loadPageUrl?: string,
  editorType?: string,
) => {
  return widgetSDK.getContext(loadPageUrl).then((context) => {
    const selectedSite = selectSelectedSite(store.getState());
    if (selectedSite?.id) {
      context.metaSiteId = selectedSite.id;
    }
    const queryParameters = {
      ...query,
      ...parameters,
      ...(editorType ? { editorType } : {}),
    };

    return httpClient
      .getInstance()
      .post<IInitialChatData>(
        clientTopology.restartChatUrl,
        {
          query: queryParameters,
          context,
        },
        {
          withCredentials: !window.isTest,
        },
      )
      .then(handleConflictStatus)
      .then(addToQueue)
      .then(debug)
      .catch((error) => {
        logger.error({
          message: 'fail to post restart chat',
          error,
          callParams: {
            query: queryParameters,
          },
        });
      });
  });
};
